export default "__VITE_ASSET__DBw5Pkv8__"